import { getField, updateField } from 'vuex-map-fields'
import insertOrganizationIdToUrl from '@/utils/insertOrganizationIdToUrl'
import { USER_AUTHENTICATION_URL } from '~/assets/variables/endpoints'

export const state = () => ({
  newUsernameMqtt: null,
  mqttSharedWorkerConnected: false,
})

export const getters = {
  getField,
  getMqttUsername(state) {
    return state.newUsernameMqtt
  },
}

export const actions = {
  getMqttCredentials({ commit, rootState }, params) {
    return new Promise((resolve, reject) => {
      const mqttCred = localStorage.getItem('mqtt-credentials')
      const mqttCredExpiresAt = mqttCred ? JSON.parse(mqttCred).expiresAt : null
      const mqttExpiresAt = mqttCredExpiresAt
        ? new Date(mqttCredExpiresAt).getTime()
        : null
      if (
        mqttExpiresAt &&
        Date.now() < mqttExpiresAt &&
        !params?.isRefreshToken
      ) {
        // mqtt cred still valid (return)
        return resolve(mqttCred)
      }
      try {
        this.$axios
          .post(
            `${insertOrganizationIdToUrl(
              USER_AUTHENTICATION_URL,
              this.$auth.user.organization_id
            )}/mqtt_jwt_credentials`
          )
          .then((res) => {
            if (res.data.status === 'success') {
              state.newUsernameMqtt = res?.data?.data?.username
              localStorage.setItem(
                'mqtt-credentials',
                JSON.stringify({
                  username: res?.data?.data?.username,
                  expiresAt: res?.data?.data?.expires_at,
                })
              )
              resolve(res?.data?.data?.username)
            } else {
              reject(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      } catch (error) {
        console.error('error: ', error)
      }
    })
  },
}

export const mutations = {
  updateField,
  SET_MQTT_SW_CONNECTED(state, connected) {
    state.mqttSharedWorkerConnected = connected
  },
}
